import { ComptaPlaceholderPage } from "@dust-tt/front/components/pages/compta/ComptaPlaceholderPage";
import { PodRouterLayout } from "@spa/app/layouts/PodRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";
import { Navigate, useLocation, useParams } from "react-router-dom";

const PodPage = withSuspense(
  () => import("@dust-tt/front/components/pages/pod/PodPage"),
  "PodPage"
);

// Redirect legacy /conversation/space/:spaceId URLs
// to the new /pods/:podId path.
function LegacySpaceToPodRedirect() {
  const { spaceId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={`../pods/${spaceId}${location.search}${location.hash}`}
      replace
    />
  );
}

export const podsRoutes: RouteObject[] = [
  {
    path: "pods/:podId",
    element: <PodRouterLayout />,
    children: [
      {
        index: true,
        element: <PodPage />,
      },
      // The dossier pages of the compta sidebar (docs/projet/interface/):
      // skeletons until each ships for real, page by page.
      {
        path: "cahier",
        element: (
          <ComptaPlaceholderPage
            title="Cahier"
            question="Qu'a trouvé la machine ? Le dossier de travail : récit, cycles, feuilles."
            spec="05-cahier.md"
          />
        ),
      },
      {
        path: "revue",
        element: (
          <ComptaPlaceholderPage
            title="Revue"
            question="Qu'est-ce que J'AI à faire ? La file des points à trancher."
            spec="06-revue.md"
          />
        ),
      },
      {
        path: "pieces",
        element: (
          <ComptaPlaceholderPage
            title="Pièces"
            question="Les justificatifs de ce client — les manquantes, et la relance."
            spec="07-pieces.md"
          />
        ),
      },
      {
        path: "tva",
        element: (
          <ComptaPlaceholderPage
            title="TVA"
            question="Ma CA3 est-elle juste ? La feuille de liquidation, case par case."
            spec="08-tva.md"
          />
        ),
      },
      {
        path: "cloture",
        element: (
          <ComptaPlaceholderPage
            title="Clôture"
            question="Je signe, et le dossier est bouclé — la check-list, le visa, le verrou."
            spec="09-cloture.md"
          />
        ),
      },
    ],
  },
  {
    path: "conversation/space/:spaceId",
    element: <LegacySpaceToPodRedirect />,
  },
];
